module.exports = __webpack_public_path__ + "img/retirement.d2cc6c06.svg";